import React, { Component } from 'react';
import Forecast from './forecast';

export default class index extends Component {
  render() {
    return (
      <div>
        <Forecast></Forecast>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/table/4new/4.3/4.3.1/history/index.js